import React, { useState, useCallback, useContext, useEffect } from 'react';
import { Dropdown, DropdownToggle } from 'reactstrap';


// import { styled } from '@mui/material/styles';
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { NotificationsNone } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Toolip from '@mui/material/Tooltip';
import Badge from '@mui/material/Badge';
import ReactGA from 'react-ga4';
import notificationNoneIcon from '../../../assets/img/notificationNoneIcon.svg';
import { NotificacaoContext } from '../../../context/NotificacaoContext';
import { Text } from "../../Text";
import history from '../../../services/history';
// import Switch from '@mui/material/Switch';

import {
	AddCircleOutlineIconStyled,
	DropdownButton,
	DropdownItemNotification,
	SwitchNotificationDiv,
	DropdownMenuStyledNotification,
	SwitchNotification,
	SwitchNotificationDivBottom,
	ImgNotificationNone
} from './styles';

import { ModalDoc } from '../../../views/Client/Dashboard/Modais/ModalDoc';

function Notification({color = 'black', notificacoes, dataNotification, dropdownOpen = false, setDropdownOpen }) {
	const { lerNotificacao } = useContext(NotificacaoContext);
	// const [checkedNotification, setCheckedNotification] = useState(true);

	const [isMobile, setIsMobile] = useState(false);

	const toggle = () => setDropdownOpen((prevState) => !prevState);

	const [modalDetalheVenda, setModalDetalheVenda] = useState(false);

	const toggleModalDetalheVenda = useCallback(() => {
		setModalDetalheVenda((oldValue) => !oldValue);
	}, []);

	// const handleChangeNotification = (event) => {
	// 	console.log('event', event.target.checked)
	// 	setCheckedNotification(event.target.checked);
	// };

	// const AntSwitch = styled(Switch)(({ theme }) => ({
	// 	width: 28,
	// 	height: 16,
	// 	padding: 0,
	// 	display: 'flex',
	// 	'&:active': {
	// 		'& .MuiSwitch-thumb': {
	// 			width: 15,
	// 		},
	// 		'& .MuiSwitch-switchBase.Mui-checked': {
	// 			transform: 'translateX(9px)',
	// 		},
	// 	},
	// 	'& .MuiSwitch-switchBase': {
	// 		padding: 2,
	// 		'&.Mui-checked': {
	// 			transform: 'translateX(12px)',
	// 			color: '#fff',
	// 			'& + .MuiSwitch-track': {
	// 				opacity: 1,
	// 				backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
	// 			},
	// 		},
	// 	},
	// 	'& .MuiSwitch-thumb': {
	// 		boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
	// 		width: 12,
	// 		height: 12,
	// 		borderRadius: 6,
	// 		transition: theme.transitions.create(['width'], {
	// 			duration: 200,
	// 		}),
	// 	},
	// 	'& .MuiSwitch-track': {
	// 		borderRadius: 16 / 2,
	// 		opacity: 1,
	// 		backgroundColor:
	// 			theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
	// 		boxSizing: 'border-box',
	// 	},
	// }));
	function handleClickTodasNotificacoesGA4() {
		ReactGA.event({
			category: "todas_notificacoes",
			action: "Verificar todas Notificações",
			label: "Verificando todas Notificações",
		});
	}

	function handleClickNotificacaoGA4() {
		ReactGA.event({
			category: "view_notificacao",
			action: "Visualizou Notificação",
			label: "Visualizando Notificação",
		});
	}

	const handleRequestNotification = (data) => {
		lerNotificacao(data.id);
		handleClickNotificacaoGA4();
		history.push({
			pathname: `/client/transacoes`,
			state: data,
		});
	};

	const handleTodasNotificacoes = () => {
		history.push(`/client/notificacoes`);
		toggle()
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 900); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<Dropdown isOpen={dropdownOpen} toggle={toggle}>
			<DropdownToggle
				tag="span"
				style={{ cursor: 'pointer' }}
				data-toggle="dropdown"
				aria-expanded={dropdownOpen}>
				<Toolip style={{ all: 'unset' }}>
					<IconButton>
						{dataNotification.total_notifications_to_read && dataNotification.total_notifications_to_read > 0 ?
							<Badge badgeContent={dataNotification.total_notifications_to_read} color="error">
								<NotificationsNone style={{color: color}} />
							</Badge>
							:
							<NotificationsNone style={{color: color}} />
						}
					</IconButton>
				</Toolip>
			</DropdownToggle>
			<DropdownMenuStyledNotification className="notification-dropdown" right>
				<SwitchNotificationDiv>
					<SwitchNotification>
						{/* <AntSwitch
							checked={checkedNotification}
							onChange={handleChangeNotification}
							inputProps={{ 'aria-label': 'controlled' }} />
						{' '} */}
						<Text />
					</SwitchNotification>
				</SwitchNotificationDiv>
				{notificacoes.length > 0 ?
					<>
						{notificacoes.map((item, index) => (
							<>
								{(index <= 3) ?
									<DropdownButton onClick={() => handleRequestNotification(item)}>
										<DropdownItemNotification>
											<AddCircleOutlineIconStyled />
											<div>
												<Text style={{ fontSize: 14 }}>{item.created_at}</Text>
												<Text style={{ fontSize: 14 }}><b>{item.subject}</b></Text>
												{item.message.length > 60 ? (
													<Text style={{ fontSize: 14 }}>
														{`${item.message.substr(
															0,
															`${isMobile ? 25 : 60}`
														)}...`}
													</Text>
												) : (
													<Text style={{ fontSize: 14 }}>{item.message}</Text>
												)}
											</div>
										</DropdownItemNotification>
									</DropdownButton>
									: <></>
								}
							</>
						))}
					</> :
					<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: '20%', paddingBottom: '20%' }}>
						<ImgNotificationNone
							style={{ paddingBottom: '20px' }}
							alt="notification"
							width="20%"
							src={notificationNoneIcon}
						/>
						<Text style={{
							color: '#929292', paddingLeft: '15px'
						}}>
							Você ainda não tem nenhuma notificação
						</Text>
					</div>
				}

				<SwitchNotificationDivBottom onClick={() => {
					handleTodasNotificacoes()
					handleClickTodasNotificacoesGA4()
				}}>
					<Text>Ver todas as notificações</Text>
					{/* <DropdownItemVerTodas
						onClick={() => history.push('/client/notificacoes')}>
						Ver todas as notificações
					</DropdownItemVerTodas> */}
				</SwitchNotificationDivBottom>
			</DropdownMenuStyledNotification>
			<ModalDoc
				toggle={toggleModalDetalheVenda}
				isOpen={modalDetalheVenda}
			/>
		</Dropdown>
	);
}

export default Notification;
